/**
 * LegalNoticePage - Mentions legales obligatoires (Belgique)
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function LegalNoticePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate('/shop')}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-800">Mentions legales</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        {/* Editeur du site */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Editeur du site</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p><strong>Les Folies Maraicheres SRL</strong></p>
            <p>
              Rue du Commerce 147<br />
              7370 Dour<br />
              Belgique
            </p>
            <p>
              Tel. : 0478/51.68.22<br />
              Email : contact@foliesboutik.be
            </p>
            <p>
              T.V.A. / numero d'entreprise : 0715954426<br />
              RPM Mons
            </p>
          </div>
        </section>

        {/* Responsable de publication */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Responsable de publication</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p><strong>Philippe Carre</strong>, gerant</p>
          </div>
        </section>

        {/* Hebergement */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Hebergement</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p><strong>OVH SAS</strong></p>
            <p>
              2, rue Kellermann<br />
              59100 Roubaix<br />
              France
            </p>
            <p>Tel. : +33 9 72 10 10 07</p>
          </div>
        </section>

        {/* Activite */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Activite</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Les Folies Maraicheres est une exploitation maraichere biologique situee a Elouges (Hainaut, Belgique).
              Nous produisons et commercialisons des produits alimentaires issus de l'agriculture biologique :
              legumes de production propre, fruits, epicerie, produits laitiers, boulangerie et autres denrees bio.
            </p>
          </div>
        </section>

        {/* Certifications */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Certifications</h2>
          <div className="space-y-4">
            <div className="p-6 bg-white border-2 border-green-200 rounded-xl">
              <h3 className="font-bold text-gray-900 text-lg mb-2">Nature & Progres</h3>
              <p className="text-gray-700">
                Mention Nature & Progres depuis 2009 : une charte associative, distincte de la
                certification biologique (voir ci-dessous). Cahier des charges plus exigeant que le
                label bio europeen : agriculture paysanne, respect de la biodiversite, circuits courts.
              </p>
            </div>
            <div className="p-6 bg-white border-2 border-green-200 rounded-xl">
              <h3 className="font-bold text-gray-900 text-lg mb-2">Agriculture biologique europeenne</h3>
              <p className="text-gray-700">
                Certificateur : <strong>Certisys</strong><br />
                Organisme de controle : <strong>BE-BIO-01</strong><br />
                Certification conforme au Reglement (UE) 2018/848 relatif a la production biologique.
              </p>
            </div>
          </div>
        </section>

        {/* Propriete intellectuelle */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Propriete intellectuelle</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              L'ensemble du contenu du site foliesboutik.be (textes, images, logos, graphismes, icones, logiciels)
              est la propriete exclusive de Les Folies Maraicheres SRL ou de ses partenaires, et est protege par
              les lois belges et internationales relatives a la propriete intellectuelle.
            </p>
            <p>
              Toute reproduction, representation, modification ou exploitation, totale ou partielle, du contenu
              du site est interdite sans autorisation prealable ecrite.
            </p>
          </div>
        </section>

        {/* Protection des donnees */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Protection des donnees personnelles</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Les Folies Maraicheres SRL s'engage a proteger vos donnees personnelles conformement au Reglement
              General sur la Protection des Donnees (RGPD). Pour en savoir plus, consultez notre{' '}
              <button
                onClick={() => navigate('/shop/privacy')}
                className="text-green-700 hover:text-green-700 underline font-medium"
              >
                Politique de confidentialite
              </button>.
            </p>
          </div>
        </section>

        {/* Litiges */}
        <section className="mb-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Droit applicable et litiges</h2>
          <div className="prose prose-lg text-gray-700 leading-relaxed">
            <p>
              Le present site est soumis au droit belge. En cas de litige, les tribunaux de l'arrondissement
              judiciaire du Hainaut sont seuls competents, apres tentative de resolution amiable.
            </p>
          </div>
        </section>

        {/* Bouton retour */}
        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/shop')}
            className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg transition-opacity hover:opacity-90"
          >
            Retour a la boutique
          </button>
        </div>
      </main>

    </div>
  );
}
